/**
 * ErrorSegnaloBanner — F-005 Phase 5 (Task 5.2).
 *
 * Inline alert shown on the detail page when a pratica is `BLOCCATA`. Surfaces
 * the operator's visible note + the contested field paths, with a CTA that links
 * to the self-service correction flow (`/pratiche/:id/correggi`).
 *
 * Promoted/refined from the sketch's `ErrorSegnaloBanner`
 * (`arness-sketches/pratica-status/SketchPraticaStatoDetail.tsx`): the static
 * mock copy is replaced with real props (`operatorNote`, `contestedFields`).
 * Reference: `features/profilo/components/ProfileIncompleteBanner.tsx`.
 */
import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

interface ErrorSegnaloBannerProps {
  praticaId: string;
  operatorNote: string | null;
  contestedFields: string[];
}

export function ErrorSegnaloBanner({
  praticaId,
  operatorNote,
  contestedFields,
}: ErrorSegnaloBannerProps) {
  return (
    <div role="alert" className="space-y-3 rounded-lg border border-amber-200 bg-amber-50 p-4">
      <div className="flex items-start gap-3">
        <AlertTriangle
          className="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-600"
          aria-hidden="true"
        />
        <div className="space-y-1">
          <p className="text-sm font-semibold text-amber-800">
            Pratica bloccata — dati da correggere
          </p>
          {operatorNote && <p className="text-sm text-amber-700">{operatorNote}</p>}
          {contestedFields.length > 0 && (
            <p className="text-xs text-amber-600">
              Campi segnalati: {contestedFields.join(', ')}
            </p>
          )}
        </div>
      </div>
      <Link
        to={`/pratiche/${praticaId}/correggi`}
        className="inline-flex items-center rounded-md bg-amber-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2"
      >
        Correggi i dati
      </Link>
    </div>
  );
}
